import { QueryBuilder } from '@pec/aion-ui-odata/builders/odataQueryBuilder';
import axios from 'axios';
import { OdataResponse } from '@pec/aion-ui-odata/types/odataResponse';
import { IAddress, ICompany, ICountry, IAddressDetails, SearchProvider, IBaseCompany } from '../types/companyDetails';
import { OdataComparator } from '@pec/aion-ui-odata/types/odataComparator';
import { IServerTokens } from '@pec/aion-ui-core/interfaces/serverTokens';
import { IUserInfo } from '@pec/aion-ui-core/interfaces/userInfo';
import { ICompleteResponseAdmin } from '../types/complete';

export const fetchCountries = async (search: string = '') => {
  const params = new QueryBuilder()
    .filter(f => f.filterBy('name', OdataComparator.Contains, search ? search : undefined))
    .orderBy('name asc')
    .toQueryParam();
  const response = await axios.get<OdataResponse<ICountry[]>>('/api/v3.3/countries', { params });
  if (response.data['@odata.count'] > 0) {
    return response.data.value.filter(item => item.name.toLowerCase().startsWith(search.toLowerCase()));
  }
  return null;
};

export const searchAddresses = (searchText: string, countryCode: string, sessionId: string) => {
  const params = {
    searchProvider: SearchProvider.GOOGLE_PLACES,
    searchText,
    countryCode,
    sessionId
  };
  return axios.get<IAddress[]>('/api/v1/signup/search', { params });
};

export const fetchAddressDetails = (id: string, sessionId: string) => {
  const params = {
    searchProvider: SearchProvider.GOOGLE_PLACES,
    id,
    sessionId
  };
  return axios.get<IAddressDetails>('/api/v1/signup/search/details', { params });
};

export const fetchCompanies = (searchProvider: SearchProvider, searchText: string) => {
  return axios.get<ICompany[]>('/api/v1/signup/search', {
    params: {
      searchProvider,
      searchText
    }
  });
};

export const fetchCompanyDetails = (
  searchProvider: SearchProvider,
  { companyName, postalCode, state }: IBaseCompany
) => {
  return axios.get<IAddressDetails>('/api/v1/signup/search/details', {
    params: {
      searchProvider,
      companyName,
      postalCode,
      state
    }
  });
};

type ServerTokensResponse = {
  serverTokens?: IServerTokens;
  redirectUri: string;
};

export const fetchServerTokens = () => {
  return axios.get<ServerTokensResponse>('/spapi/serverTokens');
};

export const fetchUserInfo = (serverTokens: IServerTokens) => {
  return axios.get<IUserInfo>('/api/v3/userInfo', {
    headers: {
      Authorization: `Bearer ${serverTokens.accessToken}`
    }
  });
};

export const createCompanyWithoutPayment = (accountId: string, serverTokens: IServerTokens) => {
  return axios.post<ICompleteResponseAdmin>(
    '/api/v1/signup-admin',
    { accountId },
    {
      headers: {
        Authorization: `Bearer ${serverTokens.accessToken}`
      }
    }
  );
};
